import 'jquery-ui/ui/widgets/slider'; // Import jQuery UI's slider
import 'jquery-ui/themes/base/slider.css'; // Import the CSS (if needed)
import $ from 'jquery';
import { useEffect, useRef } from 'react';

export function slider(hour,setFhour) {

	function debounce(func, delay) {
		let timer;
		return function () {
		  const context = this;
		  const args = arguments;
		  clearTimeout(timer);
		  timer = setTimeout(() => {
			func.apply(context, args);
		  }, delay);
		};
	  }

    const updateFhour = debounce(function(event, ui) {
        const time = ui.value;
        const paddedTime = String(time).padStart(3, '0'); // Zero pad to length 3
        setFhour(paddedTime);
    }, 200);

	$("#timeslider").slider({
		value:hour,
		min:0,
		max:240,
		step:6,
		animate:"fast",
		orientation:"horizontal",
		start: function(event, ui) {
			// Disable map dragging when the user starts interacting with the slider
		},
		slide: updateFhour, 
		change: updateFhour,
	});
}

export function windSlider(sliderLev,setSliderLev,sliderPresLev,setSliderPresLev) {
    const plevels = ["10", "1000", "925", "850", "700", "500", "300", "250", "200"];
    const plevellabels = ["200 hPa", "250 hPa", "300 hPa", "500 hPa", "700 hPa", "850 hPa", "925 hPa", "1000 hPa", "10 m"];

    $("#levelslider").slider({
        value: 0,
        orientation: "vertical",
        min: 0,
        max: 8,
        step: 1,
        animate: "fast",
        slide: function (event, ui) {
            // Add any necessary functionality here
        },
        stop: function (event, ui) {
            setSliderPresLev(plevels[ui.value])
        }
    });

    const labelContainer = document.getElementById('levelsliderlabels');
    labelContainer.innerHTML = '';
    plevellabels.forEach(level => {
        const tickContainer = document.createElement('div');
        tickContainer.className = 'tick-container';
        const label = document.createElement('div');
        label.className = 'tick-label';
        label.textContent = level;
        tickContainer.appendChild(label);
        labelContainer.appendChild(tickContainer);
    });
}

export function next(fhour, setFhour) {
    let nexthour = parseInt(fhour, 10) + 6;
    if (nexthour > 240) {
        nexthour = 240;
    }
    setFhour(String(nexthour).padStart(3, '0'));
}

export function previous(fhour, setFhour) {
    let prevhour = parseInt(fhour, 10) - 6;
    if (prevhour < 0) {
        prevhour = 0;
    }
    setFhour(String(prevhour).padStart(3, '0'));
}

export function first(fhour, setFhour) {
    setFhour("000");
}

export function last(fhour, setFhour) {
    setFhour("240");
}

export function processJump(event,setFhour) {
    const enteredValue = parseInt(event.target.value, 10);
    if (!isNaN(enteredValue) && enteredValue % 6 === 0 && enteredValue >= 0 && enteredValue <= 240) {
      const paddedValue = String(enteredValue).padStart(3, '0');
      setFhour(paddedValue);
    }
}

export function usePlayFunc({fhour, setFhour, play, setPlay, selectedInit, selectedModel, selectedVariable, compareBool, griddedMapRefs, singleMapRef, popupRef, gridModels}) {
    const isPlayingRef = useRef(false);

    useEffect(() => {
        const loopThroughFhours = async () => {
            if (!play || !$("#timeslider").slider("instance")) return;

            isPlayingRef.current = true;

            let starthour = parseInt(fhour, 10);

            $("#timeslider").slider("disable");
            $("#next, #previous, #first, #last, #jumpinput").prop("disabled", true);

            for (let hour = starthour; hour <= 240; hour += 6) {
                if (!isPlayingRef.current) break;

                setFhour(String(hour).padStart(3, '0'));
                await new Promise(resolve => setTimeout(resolve, 1000));
            }

            $("#timeslider").slider("enable");
            $("#next, #previous, #first, #last, #jumpinput").prop("disabled", false);
            setPlay(false);
            isPlayingRef.current = false;
        };

        if (play) {
            loopThroughFhours();
        }

        return () => {
            isPlayingRef.current = false;
            $("#timeslider").slider("enable");
            $("#next, #previous, #first, #last, #jumpinput").prop("disabled", false);
        };
    }, [play, fhour, setFhour, setPlay]);

    // Stop playback on dependency change such as switching modes
    useEffect(() => {
        isPlayingRef.current = false;
        setPlay(false);

        if ($("#timeslider").slider("instance")) {
            $("#timeslider").slider("enable");
        }
        $("#next, #previous, #first, #last, #jumpinput").prop("disabled", false);
    }, [selectedInit, selectedModel, selectedVariable, compareBool, setPlay]);

    return isPlayingRef;
}
